import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalVariable } from 'src/app/global';

@Injectable({
  providedIn: 'root'
})
export class CampeonatosService {

  constructor(private http: HttpClient) { }

  public obtenerListaCampeonatos(paginator){
    return this.http.get(GlobalVariable.API_SERVER_URL+"campeonatos/empresa/"+paginator.filter.id_empresa+"/pagina/"+paginator.currentPage+"/items-pagina/"+paginator.itemsPerPage+"/busqueda/"+paginator.search+"/columna/"+paginator.column+"/direccion/"+paginator.direction,GlobalVariable.httpOptions);
  }

  public obtenerCampeonatosEmpresa(id_empresa){
    return this.http.get(GlobalVariable.API_SERVER_URL+"campeonatos/empresa/"+id_empresa,GlobalVariable.httpOptions);
  }

  public guardarCampeonato(campeonato){
    return this.http.post(GlobalVariable.API_SERVER_URL+"campeonatos/",campeonato,GlobalVariable.httpOptions);
  }

  public actualizarCampeonato(campeonato){
    return this.http.put(GlobalVariable.API_SERVER_URL+"campeonatos/"+campeonato.id,campeonato,GlobalVariable.httpOptions);
  }

  public actualizarComfiguracionTarjetaJugadorCampeonato(campeonato){
    return this.http.put(GlobalVariable.API_SERVER_URL+"configuracion_tarjeta_jugador/campeonato/"+campeonato.id,campeonato,GlobalVariable.httpOptions);
  }

  public guardarEquipo(equipo){
    return this.http.post(GlobalVariable.API_SERVER_URL+"equipos/",equipo,GlobalVariable.httpOptions);
  }

  public actualizarEquipo(equipo){
    return this.http.put(GlobalVariable.API_SERVER_URL+"equipos/"+equipo.id,equipo,GlobalVariable.httpOptions);
  }

  public obtenerCombosMatriz(id_campeonato){
    return this.http.get(GlobalVariable.API_SERVER_URL+"matriz-combos/campeonato/"+id_campeonato,GlobalVariable.httpOptions);
  }

  public obtenerListaEquipos(id_campeonato,id_categoria,id_disciplina){
    return this.http.get(GlobalVariable.API_SERVER_URL+"equipos/campeonato/"+id_campeonato+"/categoria/"+id_categoria+"/disciplina/"+id_disciplina,GlobalVariable.httpOptions);
  }

  public obtenerListaJugadores(id_empresa,id_equipo){
    return this.http.get(GlobalVariable.API_SERVER_URL+"jugadores/empresa/"+id_empresa+"/equipo/"+id_equipo,GlobalVariable.httpOptions);
  }

  public guardarJugador(jugador){
    return this.http.post(GlobalVariable.API_SERVER_URL+"jugadores/",jugador,GlobalVariable.httpOptions);
  }

  public actualizarJugador(jugador){
    return this.http.put(GlobalVariable.API_SERVER_URL+"jugadores/"+jugador.id,jugador,GlobalVariable.httpOptions);
  }

  public eliminarJugador(jugador){
    return this.http.patch(GlobalVariable.API_SERVER_URL+"jugadores/"+jugador.jugador.id,jugador,GlobalVariable.httpOptions);
  }

  public buscarJugador(id_campeonato,texto){
    return this.http.get(GlobalVariable.API_SERVER_URL+"jugadores/campeonato/"+id_campeonato+"/texto/"+texto, GlobalVariable.httpOptions);
  }

  public buscarJugadorEmpresa(id_empresa,texto){
    return this.http.get(GlobalVariable.API_SERVER_URL+"jugadores/empresa/"+id_empresa+"/texto/"+texto, GlobalVariable.httpOptions);
  }

  public obtenerClienteEquipos(id_cliente){
    return this.http.get(GlobalVariable.API_SERVER_URL+"equipos/cliente/"+id_cliente, GlobalVariable.httpOptions);
  }

  public obtenerHistorialJugadoresCliente(id_cliente,id_equipo){
    return this.http.get(GlobalVariable.API_SERVER_URL+"jugadores/historial/cliente/"+id_cliente+"/equipo/"+id_equipo, GlobalVariable.httpOptions);
  }

  public vincularJugadoresEquipo(datos){
    return this.http.post(GlobalVariable.API_SERVER_URL+"jugadores/vincular",datos,GlobalVariable.httpOptions);
  }

  public obtenerJugadoresDuplicados(id_empresa){
    return this.http.get(GlobalVariable.API_SERVER_URL+"tor-duplicados/empresa/"+id_empresa, GlobalVariable.httpOptions);
  }

  public unificarTodosJugadoresDuplicados(id_empresa,excluir){
    return this.http.post(GlobalVariable.API_SERVER_URL+"tor-duplicados/empresa/"+id_empresa,{excluir:excluir},GlobalVariable.httpOptions);
  }

  public obtenerPartidosEquipo(id_equipo){
    return this.http.get(GlobalVariable.API_SERVER_URL+"partidos/equipo/"+id_equipo, GlobalVariable.httpOptions);
  }

  public actualizarAtributoEquipo(datos){
    return this.http.post(GlobalVariable.API_SERVER_URL+"actualizar-atributo-equipos",datos,GlobalVariable.httpOptions);
  }
  
  public actualizarAtributoJugador(datos){
    return this.http.post(GlobalVariable.API_SERVER_URL+"actualizar-atributo-jugadores",datos,GlobalVariable.httpOptions);
  }

  public obtenerListaJugadoresSinCarnet(id_empresa){
    return this.http.get(GlobalVariable.API_SERVER_URL+"jugadores/sin-carnet/"+id_empresa,GlobalVariable.httpOptions);
  }

  public buscarCiJugador(id_empresa,ci){
    return this.http.get(GlobalVariable.API_SERVER_URL+"jugador/empresa/"+id_empresa+"/ci/"+ci,GlobalVariable.httpOptions);
  }

  public obtenerClientesCampeonato(id_campeonato){
    return this.http.get(GlobalVariable.API_SERVER_URL+"clientes/campeonato/"+id_campeonato,GlobalVariable.httpOptions);
  }

  //deudas por jugador: division de las deudas colectivas del club y lo que debe cada jugador
  public obtenerDivisionesVentas(ids_ventas){
    return this.http.get(GlobalVariable.API_SERVER_URL+"tor-deudas/ventas/"+ids_ventas.join(","),GlobalVariable.httpOptions);
  }

  public obtenerDatosDivisionVenta(id_venta,id_campeonato){
    return this.http.get(GlobalVariable.API_SERVER_URL+"tor-deudas/venta/"+id_venta+"/campeonato/"+id_campeonato,GlobalVariable.httpOptions);
  }

  public guardarDivisionVenta(id_venta,datos){
    return this.http.post(GlobalVariable.API_SERVER_URL+"tor-deudas/venta/"+id_venta+"/division",datos,GlobalVariable.httpOptions);
  }

  public quitarDivisionVenta(id_venta){
    return this.http.delete(GlobalVariable.API_SERVER_URL+"tor-deudas/venta/"+id_venta+"/division",GlobalVariable.httpOptions);
  }

  public obtenerFichaDeudaJugador(id_jugador,id_empresa){
    return this.http.get(GlobalVariable.API_SERVER_URL+"tor-deudas/jugador/"+id_jugador+"/empresa/"+id_empresa,GlobalVariable.httpOptions);
  }

  public obtenerDeudasJugadoresCliente(id_cliente,id_campeonato){
    return this.http.get(GlobalVariable.API_SERVER_URL+"tor-deudas/cliente/"+id_cliente+"/campeonato/"+id_campeonato,GlobalVariable.httpOptions);
  }

  //ventas de inscripcion del cliente que se le podrian enlazar a este equipo
  public obtenerVentasInscripcionCliente(id_cliente,id_equipo){
    return this.http.get(GlobalVariable.API_SERVER_URL+"ventas-inscripcion/cliente/"+id_cliente+"/equipo/"+id_equipo,
      GlobalVariable.httpOptions);
  }

  //enlaza la venta al equipo; con id_venta en null, quita el enlace
  public establecerVentaInscripcion(id_equipo,id_venta){
    return this.http.put(GlobalVariable.API_SERVER_URL+"equipos/"+id_equipo+"/venta-inscripcion",
      { id_venta:id_venta },GlobalVariable.httpOptions);
  }
}
